// frontend/src/pages/admin/statusLabels.js
// Shared mapping from raw rental status values (as stored by the API) to the
// `admin.status.*` i18n keys, used by the Dashboard, Rentals and Customers pages.

export const STATUS_KEYS = {
  pending_payment: 'pendingPayment',
  paid:            'paid',
  picked_up:       'pickedUp',
  returned:        'returned',
  late:            'late',
  cancelled:       'cancelled',
  disputed:        'disputed',
  lost:            'lost',
};

// Translate a raw status; falls back to the previous humanised rendering for
// any status the API may add that we don't have a label for yet.
export function statusLabel(t, status) {
  const key = STATUS_KEYS[status];
  if (key) return t(`admin.status.${key}`);
  return status ? status.replace('_', ' ').toUpperCase() : '';
}
